import { Box, styled } from '@mui/material';
import api from '../../utils/api';
import { useConfig } from '../../Hooks/useConfig';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';

const SocialMediaBox = styled(Box)(({ theme }) => ({
  border: '1px solid #C2C8D0',
  padding: '11px 8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 400,
  borderRadius: '3px',
  fontSize: '14px',
  margin: theme.spacing(0, 1),
  cursor: 'pointer',
  width: '100%',
  transition: 'all .2s linear',
  '&:hover': {
    backgroundColor: '#E5E5E5',
  },
  p: {
    width: '180px',
  },
  img: {
    width: theme.spacing(4.5),
    marginRight: theme.direction === 'ltr' ? theme.spacing(6) : 0,
    marginLeft: theme.direction === 'rtl' ? theme.spacing(6) : 0,
  },
  marginBottom: theme.spacing(3),
  '&:last-of-type': {
    marginBottom: theme.spacing(0),
  },
}));

const SocialMediaCard = ({ media }) => {
  const { panelUrl } = useConfig();
  const project = panelUrl.includes(window.location.hostname)
    ? 'panel'
    : 'playground';
  const locationRouter = useLocation();
  const { t } = useTranslation();

  const getTargetUrl = async (mediaName = '') => {
    const TargetUrlReq = await api.call({
      name: 'loginProvider',
      queryParam: `${mediaName}/${project}`,
    });
    if (TargetUrlReq.status === 200) {
      window.location.href = TargetUrlReq.data.data.target_url;
      location.search
        ? localStorage.setItem('redirectUrl', location.search)
        : locationRouter.state.from
          ? localStorage.setItem(
              'redirectUrl',
              locationRouter.state.from.replace('/', '')
            )
          : '';
    }
  };

  return (
    <>
      <SocialMediaBox onClick={() => getTargetUrl(media.value)}>
        <img src={`/static/img/icon/${media.icon}`} />
        <p>
          {t('login.continue_with')} {media.name}
        </p>
      </SocialMediaBox>
    </>
  );
};
export default SocialMediaCard;
